import axiosAuth from '../../axiosMain';

async function index(year) {
  let response = await axiosAuth.get('/total_gas_and_fuel_consumption/' + year);
  return response.data;
}

export default {
  index,
};
